module.exports = __webpack_public_path__ + "img/ros_gold.fafdb5d.png";